export const getTranslatedReason = (
  type,
  appointmentReasons,
  language = "en"
) => {
  return appointmentReasons.find?.((r) => r.en === type)?.[language] || type;
};
